import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeller } from '../../../context/SellerContext';
import SellerDetailPage from '../SellerDetailPage';

/**
 * Wraps SellerDetailPage with fixedTab="notifications" for the selected seller.
 */
export default function SellerNotificationConfigPage() {
  const navigate = useNavigate();
  const { selectedSeller } = useSeller();

  if (!selectedSeller?.id) {
    navigate('/sellers', { replace: true });
    return null;
  }

  return <SellerDetailPage fixedTab="notifications" sellerId={selectedSeller.id} />;
}
